import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Paragraph } from 'evergreen-ui';

function Footer(){

  return(
    <footer className="mt-7 justify-content-between">
      <Container>
        <Row style={{color: 'goldenrod'}} className=" justify-content-between p-3">

          <Paragraph style={{color: 'goldenrod'}} className="p-0 d-flex justify-content-end" md={3}>
          Produced on 4/7/2020. Using React.
          </Paragraph>

        </Row>
      </Container>
    </footer>

  );

}
export default Footer
